/**
 * (c) 2025
 * written by Marco Aveta
 * I-PLAN
 *
 * i18n initialization and dynamic menu rendering
 * Language priority: localStorage > env > default ("it")
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as api from "../../api/apiConnector.js";
import { 
  loadChecklistGroups, 
  handleChecklistMenu,
  hasRootRights,
  hasAdministrationRights,
  hasHandHygieneRights,
  hasDMSRights,
  hasUserAndGroupManagementRights,
  hasOrganizationChartRights,
  hasDictionaryRights,
  hasFormBuilderRights,
  hasFormAssignRights,
  hasFormValidateRights,
  hasRightsTreeManagementRights,
  hasSystemConfigurationRights,
  hasPowerBIReportsRights,
  hasSpecificRight
} from './menu_helper.js';
const language = localStorage.getItem("language") || process.env.REACT_APP_LANGUAGE || "it";
const t = i18n.t;



/**
 * Write user info to the UI
 */
const write_user = ({ user }) => {
  const $ = window.$;
  const container = $("#connected-user");
  container.html("");
  container.append($("<h6/>").text(`${user.Name} ${user.LastName}`));
  container.append($("<p/>").text(user.EMail));

  $("#yourNameSubHeaderMenu").html(`<h6>${user.Name} ${user.LastName}</h6>`);
  $("#yourMailSubHeaderMenu").html(`<span>${user.EMail}</span>`);
  
  // Show/hide change password button based on IS_SSO environment variable
  const isSSO = process.env.REACT_APP_IS_SSO;
  const changePasswordBtn = $("#changePasswordBtn");
  if (isSSO === "false" || isSSO === false) {
    changePasswordBtn.show();
  } else {
    changePasswordBtn.hide();
  }
};

/**
 * Write navigation menu to the UI
 */
const write = async ({ user }) => {
  if (user) write_user({ user });

  i18n
    .use(initReactI18next)
    .init({
      lng: language,
      resources: {
        it: {
          translation: {
            menu: {
              main: "Home",
              modules: "Moduli",
              dashboard: "Dashboard",
              dms: {
                title: "DMS",
                documents: "Cartella utente",
                //meets: "Registrazioni meet",
                root: "Documenti"
              },
              admin: {
                title: "Admin",
                usersGroups: {
                  find: "Ricerca utenti e gruppi",
                  addUser: "Nuovo utente",
                  addGroup: "Nuovo gruppo"
                },

                organization: {
                  chart: "Organigramma",
                },
                security: {
                  rightsTree: "Albero dei diritti"
                },
                vocs: {
                  title: "Vocs",
                  orgRoles: "Voc ruoli organizzativi",
                  funcRoles: "Voc ruoli funzionali",
                  unitTypes: "Voc tipi di unità aziendali",
                  vocDepartmentHandHygiene: "Voc dipartimenti igiene mani",
                  vocOperatorsHandHygiene: "Voc operatori igiene mani",
                  vocRisksArea: `Voc livello di rischio`,
                  vocAreaSpecialty: `Voc Area/Specialità`,
                  vocFormGroup: `Voc gruppi di form`,
                  formCustomVocs: "Voc custom form",
                  hospitalRegimenTypes: "Voc regimi ospedalieri",
                  dmsClassificationType: "Voc classificazione File",
                  dmsCategoryType:"Voc categorie dms",
                  dmsFilesValidationFlow:"Voc flusso validazione file",
                  dmsKeyWords:`Voc parole chiavi`
                },
                configuration: {
                  title: "Configurazioni sistema",
                  manage: "Gestisci configurazioni"
                },
                dataImport: {
                  title: "Import Dati",
                  manage: "Gestisci importazione dati"
                },
                lis: {
                  title: "LIS",
                  sourceDataTable: "Dati LIS sorgente",
                  microbiologicalDataExplorer: "Dati LIS normalizzati",
                  vocManagement: "Gestisci vocabolari",
                  alertRules: "Regole Alert",
                  alertAssignment: "Assegnazione alert",
                  notificationSettings: "Impostazioni Notifiche Alert LIS",
                  systemStatus: "Monitor stato sistema",
                  checklistDashboard: "Dashboard Question HAI"
                },
                form: {
                  title: "Form Builder",
                  formBuilder: "Crea Form",
                  formBuilderFinder: "Cerca Form",
                  acpmFinder: "ACPM finder",
                  formAssignments: "Assegna Form",
                  formsDashboard: "Forms dashboard",
                  validationDashboard: "Valida Form"
                },
                users: {
                  title: "Utenti e gruppi",
                  find: "Cerca",
                  addUser: "Nuovo utente",
                  addGroup: "Nuovo gruppo"
                },
              },
              reports: {
                title: "Reports",
                description: "Report e analytics"
              },
              hygiene: {
                title: "Igiene delle mani",
                new: "Nuova osservazione",
                history: "Storico"
              },
              acpm: {
                title: "ACPM",
                finder: "Ricerca ACPM"
              },
              sentinel: {
                title: "Prevenzione eventi sentinella",
                new: "Nuovo evento",
                history: "Storico"
              },
              incident: {
                title: "Incident reporting",
                new: "Nuovo incidente",
                history: "Storico"
              },
              micro: {
                title: "MICRO",
                report: "Report"
              },
              ica: {
                title: "Integrazione e notifica sospetta ICA",
                new: "Nuova notifica",
                history: "Storico"
              },
              gel: {
                title: "Consumi gel idroalcolico",
                report: "Report"
              },
              ddd: {
                title: "Consumi antibiotici in DDD",
                report: "Report"
              },
              devices: {
                title: "Consumo dispositivi medici",
                report: "Report"
              },
              prevalence: {
                title: "Indagine di prevalenza",
                report: "Report"
              },
              cleaning: {
                title: "Pulizie e sanificazione ambientale",
                checklist: "Checklist",
                report: "Report"
              },
              sterilization: {
                title: "Decontaminazione e sterilizzazione",
                checklist: "Checklist",
                report: "Report"
              },
              laundry: {
                title: "Servizi di lavanolo",
                checklist: "Checklist",
                report: "Report"
              },
              waste: {
                title: "Smaltimento rifiuti sanitari",
                checklist: "Checklist",
                report: "Report"
              },
              catering: {
                title: "Servizio ristorazione",
                checklist: "Checklist",
                report: "Report"
              },
              disinfectants: {
                title: "Disinfettanti",
                checklist: "Checklist",
                report: "Report"
              },
              visitors: {
                title: "Accesso visitatori",
                checklist: "Checklist",
                report: "Report"
              },
              injuries: {
                title: "Infortuni e malattie",
                checklist: "Checklist",
                report: "Report"
              },
              contamination: {
                title: "Prevenzione contaminazione",
                checklist: "Checklist",
                report: "Report"
              },
              infections: {
                title: "Prevenzione infezioni",
                checklist: "Checklist",
                report: "Report"
              },
              isolation: {
                title: "Isolamento protettivo",
                checklist: "Checklist",
                report: "Report"
              },
              dressing: {
                title: "Vestizione/Svestizione",
                checklist: "Checklist",
                report: "Report"
              },
              pneumonia: {
                title: "Prevenzione polmonite",
                checklist: "Checklist",
                report: "Report"
              },
              water: {
                title: "Qualità acqua",
                checklist: "Checklist",
                report: "Report"
              },
              microbiologia: {
                title: "Microbiologia",
                notifiche: "Notifiche",
                schede: "Schede"
              },
              formsDashboard: {
                title: "Dashboard Assegnazioni"
              },
              checklist: {
                title: "CheckList",
                compile: "Compila",
                history: "Storico"
              },
              // Language selector labels
              languageSelector: {
                selectLanguage: 'Seleziona lingua',
                changeLanguage: 'Cambio lingua',
                languageSelected: 'Lingua selezionata!',
                languageChanged: 'Lingua modificata correttamente'
              }
            }
          },

        },
        en:
        {
          translation: {
            menu: {
              main: "Home",
              modules: "Modules",
              dashboard: "Dashboard",
              dms: {
                title: "DMS",
                documents: "Documents",
                meets: "Meeting recordings",
                root: "Root"
              },
              admin: {
                title: "Admin",
                usersGroups: {
                  find: "Search users and groups",
                  addUser: "New user",
                  addGroup: "New group"
                },
                organization: {
                  chart: "Organization chart",
                  functional: "Functional chart"
                },
                security: {
                  rightsTree: "Rights tree"
                },
                vocs: {
                  title: "Vocs",
                  orgRoles: "Voc organizational roles",
                  funcRoles: "Voc functional roles",
                  unitTypes: "Voc business unit types",
                  vocDepartmentHandHygiene: "Voc hand hygiene departments",
                  vocOperatorsHandHygiene: "Voc hand hygiene operators",
                  vocRisksArea: "Voc risk level",
                  vocAreaSpecialty: "Voc Area/Specialty",
                  vocFormGroup: "Voc form groups",
                  formCustomVocs: "Voc custom form",
                  hospitalRegimenTypes: "Voc hospital regimens",
                  dmsClassificationType: "Voc file classification",
                  dmsCategoryType:"Voc dms categories",
                  dmsFilesValidationFlow:"Voc validation flow file",
                  dmsKeyWords:`Vocs keywords`
                },
                configuration: {
                  title: "System configurations",
                  manage: "Manage configurations"
                },
                dataImport: {
                  title: "Data import",
                  manage: "Manage data import"
                },
                lis: {
                  title: "LIS",
                  sourceDataTable: "LIS Source Data",
                  microbiologicalDataExplorer: "LIS Normalized Data",
                  vocManagement: "Manage vocabularies",
                  alertRules: "Alert Rules",
                  alertAssignment: "Alert assignment",
                  notificationSettings: "LIS Alert Notification Settings",
                  systemStatus: "System status monitor",
                  checklistDashboard: "Dashboard Question HAI"
                },
                form: {
                  title: "Form builder",
                  formBuilder: "Create Form",
                  formBuilderFinder: "Search Forms",
                  acpmFinder: "ACPM finder",
                  formAssignments: "Assign Forms",
                  formsDashboard: "Forms dashboard",
                  validationDashboard: "Validate Forms"
                },
                users: {
                  title: "Users and groups",
                  find: "Search",
                  addUser: "New user",
                  addGroup: "New group"
                }
              },
              reports: {
                title: "Reports",
                description: "Reports and analytics"
              },
              hygiene: {
                title: "Hand hygiene",
                new: "New observation",
                history: "History"
              },
              acpm: {
                title: "ACPM",
                finder: "ACPM Search"
              },
              sentinel: {
                title: "Sentinel event prevention",
                new: "New event",
                history: "History"
              },
              incident: {
                title: "Incident reporting",
                new: "New incident",
                history: "History"
              },
              micro: {
                title: "MICRO",
                report: "Report"
              },
              ica: {
                title: "Integration and notification of suspected HAI",
                new: "New notification",
                history: "History"
              },
              gel: {
                title: "Alcohol-based gel consumption",
                report: "Report"
              },
              ddd: {
                title: "Antibiotic consumption in DDD",
                report: "Report"
              },
              devices: {
                title: "Medical device consumption",
                report: "Report"
              },
              prevalence: {
                title: "Prevalence survey",
                report: "Report"
              },
              cleaning: {
                title: "Cleaning and environmental sanitization",
                checklist: "Checklist",
                report: "Report"
              },
              sterilization: {
                title: "Decontamination and sterilization",
                checklist: "Checklist",
                report: "Report"
              },
              laundry: {
                title: "Laundry services",
                checklist: "Checklist",
                report: "Report"
              },
              waste: {
                title: "Healthcare waste disposal",
                checklist: "Checklist",
                report: "Report"
              },
              catering: {
                title: "Catering service",
                checklist: "Checklist",
                report: "Report"
              },
              disinfectants: {
                title: "Disinfectants",
                checklist: "Checklist",
                report: "Report"
              },
              visitors: {
                title: "Visitor access",
                checklist: "Checklist",
                report: "Report"
              },
              injuries: {
                title: "Injuries and illnesses",
                checklist: "Checklist",
                report: "Report"
              },
              contamination: {
                title: "Contamination prevention",
                checklist: "Checklist",
                report: "Report"
              },
              infections: {
                title: "Infection prevention",
                checklist: "Checklist",
                report: "Report"
              },
              isolation: {
                title: "Protective isolation",
                checklist: "Checklist",
                report: "Report"
              },
              dressing: {
                title: "Dressing/Undressing",
                checklist: "Checklist",
                report: "Report"
              },
              pneumonia: {
                title: "Pneumonia prevention",
                checklist: "Checklist",
                report: "Report"
              },
              water: {
                title: "Water quality",
                checklist: "Checklist",
                report: "Report"
              },
              microbiologia: {
                title: "Microbiology",
                notifiche: "Notifications",
                schede: "Forms"
              },
              formsDashboard: {
                title: "Forms dashboard"
              },
              checklist: {
                title: "CheckList",
                compile: "Compile",
                history: "History"
              },
              // Language selector labels
              languageSelector: {
                selectLanguage: 'Select language',
                changeLanguage: 'Change language',
                languageSelected: 'Language selected!',
                languageChanged: 'Language changed successfully'
              }
            }
          }
        }
        // Language selector supports Italian and English only
      }
    });

  const $ = window.$;
  const is = (urlPart) => window.location.href.includes(urlPart);
  const ends = (urlEnd) => window.location.href.endsWith(urlEnd);

  const menu = $(".metismenu");
  menu.html("");

  const userHasDMSRights = hasDMSRights(user);
  const userHasHandHygiene = hasHandHygieneRights(user);
  const userHasPowerBIReports = hasPowerBIReportsRights(user);

  // Load checklist groups for dynamic menu
  let checklistGroups = [];
  try {
    checklistGroups = await loadChecklistGroups(() => user);
  } catch (err) {
    console.error("Error loading checklist groups for menu:", err);
    checklistGroups = []; // Assicura che sia sempre un array
  }

  const addMenuItem = (html) => menu.append(html);

  addMenuItem(`<li class="menu-title">${t("menu.main")}</li>`);
  addMenuItem(`
      <li class="${is("/dashboard") ? "mm-active" : ""}">
        <a href="/dashboard">
          <div class="menu-icon"><i class="fa fa-chart-line"></i></div>
          <span class="nav-text">${t("menu.dashboard")}</span>
        </a>
      </li>
    `);
  
  // Show BFM button only in debug mode
  if (process.env.REACT_APP_IS_DEBUG === "true") {
    addMenuItem(`
        <li class="${is("/flowise") ? "mm-active" : ""}">
          <a href="/flowise">
            <div class="menu-icon"><i class="fa fa-robot"></i></div>
            <span class="nav-text">BFM</span>
          </a>
        </li>
      `);
  }

  addMenuItem(`<li class="menu-title">${t("menu.modules")}</li>`);

  const modules = [
    // Clinical and infectious risk management
    { key: "hygiene", icon: "fa-hand-sparkles", newPath: "/darm/handHygiene", historyPath: "/darm/handHygiene/finder" },
    { key: "formsDashboard", icon: "fa-chart-bar", reportPath: "/form_builder/dashboard" },
    { key: "reports", icon: "fa-chart-pie", reportPath: "/reports" },
    { key: "checklist", icon: "fa-list-check" },
    
    // Form Builder section (extracted from Admin)
    {
      key: "form", icon: "fa-wpforms", children: [
        { path: "/form_builder", labelKey: "formBuilder", requiredRight: "formBuilder" },
        { path: "/form_builder/finder", labelKey: "formBuilderFinder", requiredRight: "formBuilder", alternativeRight: "formAssign" },
        { path: "/form/assignments", labelKey: "formAssignments", requiredRight: "formAssign" },
        { path: "/form_builder/validation", labelKey: "validationDashboard", requiredRight: "formValidate" }
      ]
    },
    
    // Vocs section (extracted from Admin)
    {
      key: "vocs", icon: "fa-book", children: [
        { path: "/admin/vocs/organizational_chart_roles", labelKey: "orgRoles", requiredRight: "dictionary" },
        { path: "/admin/vocs/functional_chart_roles", labelKey: "funcRoles", requiredRight: "dictionary" },
        { path: "/admin/vocs/business_unit_types", labelKey: "unitTypes", requiredRight: "dictionary" },
        { path: "/admin/vocs/hand_hygiene_oms_departments_category", labelKey: "vocDepartmentHandHygiene", requiredRight: "dictionary" },
        { path: "/admin/vocs/hand_hygiene_oms_operators", labelKey: "vocOperatorsHandHygiene", requiredRight: "dictionary" },
        { path: "/admin/vocs/risk_area", labelKey: "vocRisksArea", requiredRight: "dictionary" },
        { path: "/admin/vocs/area_specialty", labelKey: "vocAreaSpecialty", requiredRight: "dictionary" },
        { path: "/admin/vocs/form_groups", labelKey: "vocFormGroup", requiredRight: "dictionary" },
        { path: "/admin/form_custom_vocs", labelKey: "formCustomVocs", requiredRight: "dictionary" },
        { path: "/admin/vocs/hospital_regimen_types", labelKey: "hospitalRegimenTypes", requiredRight: "dictionary" },
        { path: "/admin/vocs/dms_classification_types", labelKey: "dmsClassificationType", requiredRight: "dictionary" },
        { path: "/admin/vocs/dms_category_types", labelKey: "dmsCategoryType", requiredRight: "dictionary" },
        { path: "/admin/vocs/dms_files_validation_flow", labelKey: "dmsFilesValidationFlow", requiredRight: "dictionary" },
        { path: "/admin/vocs/dms_keywords", labelKey: "dmsKeyWords", requiredRight: "dictionary" }
      ]
    },
    
    // Users section (extracted from Admin)
    {
      key: "users", icon: "fa-users", children: [
        { path: "/admin/users_and_groups", labelKey: "find", requiredRight: "userAndGroupManagement" },
        { path: "/admin/user", labelKey: "addUser", requiredRight: "userAndGroupManagement" },
        { path: "/admin/group", labelKey: "addGroup", requiredRight: "userAndGroupManagement" }
      ]
    },
    // { key: "sentinel", icon: "fa-exclamation-triangle", newPath: "/sentinel/new", historyPath: "/sentinel/history" },
    // { key: "incident", icon: "fa-bolt", newPath: "/incident/new", historyPath: "/incident/history" },
    // { key: "micro", icon: "fa-microscope", reportPath: "/micro/report" },
    // { key: "ica", icon: "fa-viruses", newPath: "/ica/new", historyPath: "/ica/history" },
    // { key: "gel", icon: "fa-pump-soap", reportPath: "/gel/report" },
    // { key: "ddd", icon: "fa-pills", reportPath: "/ddd/report" },
    // { key: "devices", icon: "fa-stethoscope", reportPath: "/devices/report" },
    // { key: "prevalence", icon: "fa-notes-medical", reportPath: "/prevalence/report" },

    
    // Infection prevention and control
    // { key: "cleaning", icon: "fa-broom", checklistPath: "/cleaning/checklist", reportPath: "/cleaning/report" },
    // { key: "sterilization", icon: "fa-shield-virus", checklistPath: "/sterilization/checklist", reportPath: "/sterilization/report" },
    // { key: "laundry", icon: "fa-tshirt", checklistPath: "/laundry/checklist", reportPath: "/laundry/report" },
    // { key: "waste", icon: "fa-trash", checklistPath: "/waste/checklist", reportPath: "/waste/report" },
    // { key: "catering", icon: "fa-utensils", checklistPath: "/catering/checklist", reportPath: "/catering/report" },
    // { key: "disinfectants", icon: "fa-spray-can", checklistPath: "/disinfectants/checklist", reportPath: "/disinfectants/report" },
    // { key: "visitors", icon: "fa-user-friends", checklistPath: "/visitors/checklist", reportPath: "/visitors/report" },
    // { key: "injuries", icon: "fa-briefcase-medical", checklistPath: "/injuries/checklist", reportPath: "/injuries/report" },
    // { key: "contamination", icon: "fa-virus-slash", checklistPath: "/contamination/checklist", reportPath: "/contamination/report" },
    // { key: "infections", icon: "fa-lungs-virus", checklistPath: "/infections/checklist", reportPath: "/infections/report" },
    // { key: "isolation", icon: "fa-user-lock", checklistPath: "/isolation/checklist", reportPath: "/isolation/report" },
    // { key: "dressing", icon: "fa-tshirt", checklistPath: "/dressing/checklist", reportPath: "/dressing/report" },
    // { key: "pneumonia", icon: "fa-lungs", checklistPath: "/pneumonia/checklist", reportPath: "/pneumonia/report" },
    // { key: "water", icon: "fa-tint", checklistPath: "/water/checklist", reportPath: "/water/report" },

    // Microbiologia section (only shown in debug mode, same flag as LIS)
    ...(process.env.REACT_APP_IS_DEBUG === "true" ? [{
      key: "microbiologia",
      icon: "fa-microscope",
      children: [
        { path: "/admin/lis_alert_assignment", labelKey: "notifiche" },
        { path: "/lis/checklist_dashboard", labelKey: "schede", requiredRight: "formAssign", alternativeRight: "formBuilder" }
      ]
    }] : []),

    // DMS
    {
      key: "dms", icon: "fa-folder-tree", children: [
        { path: "/dms", labelKey: "root" },
        { path: "/dms/documents", labelKey: "documents" },
        //{ path: "/dms/meets", labelKey: "meets" }
      ]
    },

    // Admin section (without Users - now standalone)
    {
      key: "admin", icon: "fa-cog", children: [
        // LIS Submenu - FIRST ITEM (only shown in debug mode)
        ...(process.env.REACT_APP_IS_DEBUG === "true" ? [{ 
          isSubmenu: true,
          labelKey: "lis.title",
          children: [
            { path: "/admin/system_status", labelKey: "lis.systemStatus", requiredRight: "systemConfiguration" },
            { path: "/admin/lis_voc_management", labelKey: "lis.vocManagement", requiredRight: "systemConfiguration" },
            { path: "/admin/source_data_table", labelKey: "lis.sourceDataTable", requiredRight: "systemConfiguration" },
            { path: "/admin/microbiological_data_explorer", labelKey: "lis.microbiologicalDataExplorer", requiredRight: "systemConfiguration" },
            { path: "/admin/lis_alert_rules", labelKey: "lis.alertRules", requiredRight: "systemConfiguration" },
            { path: "/admin/lis_alert_notification_settings", labelKey: "lis.notificationSettings", requiredRight: "systemConfiguration" }
          ]
        }] : []),
        { path: "/admin/organization/business_units", labelKey: "organization.chart", requiredRight: "organizationChart" },
        //{ path: "/admin/organization/functional_chart", labelKey: "organization.functional", requiredRight: "organizationChart" },
        { path: "/admin/security/rights_tree", labelKey: "security.rightsTree", requiredRight: "rightsTreeManagement" },
        { path: "/admin/configurations", labelKey: "configuration.manage", requiredRight: "systemConfiguration" },
        { path: "/admin/data_import", labelKey: "dataImport.manage", requiredRight: "systemConfiguration" }
      ]
    }
  ];

  // Add ACPM module conditionally if REACT_APP_DEFAULT_APCM is defined
  if (process.env.REACT_APP_DEFAULT_APCM) {
    modules.splice(1, 0, { key: "acpm", icon: "fa-clipboard-check", reportPath: `/acpm/finder/${process.env.REACT_APP_DEFAULT_APCM}` });
  }

  modules.forEach((mod) => {
    // Skip DMS module if user doesn't have DMS rights
    if (mod.key === "dms" && !userHasDMSRights) {
      return;
    }

    // Skip Hand_Hygiene module if user doesn't have hand hygiene rights
    if (mod.key === "hygiene" && !userHasHandHygiene) {
      return;
    }

    // Skip Forms Dashboard module if user doesn't have formBuilder rights
    if (mod.key === "formsDashboard" && !hasFormBuilderRights(user)) {
      return;
    }

    // Skip Reports module if user doesn't have PowerBI Reports rights
    if (mod.key === "reports" && !userHasPowerBIReports) {
      return;
    }

    // Handle CheckList module using the dedicated module
    if (handleChecklistMenu(mod, checklistGroups, t, addMenuItem)) {
      return; // CheckList module was handled
    }
    
    // For modules with children, the visibility is determined by filtered children below
    // No need for preventive checks on admin, form, vocs - they will be shown if at least one child is visible

    if (mod.newPath && mod.historyPath) {
      addMenuItem(`
          <li>
            <a class="has-arrow" href="#">
              <div class="menu-icon"><i class="fa ${mod.icon}"></i></div>
              <span class="nav-text">${t(`menu.${mod.key}.title`)}</span>
            </a>
            <ul class="mm-collapse">
              <li><a href="${mod.newPath}">${t(`menu.${mod.key}.new`)}</a></li>
              <li><a href="${mod.historyPath}">${t(`menu.${mod.key}.history`)}</a></li>
            </ul>
          </li>
        `);
    } else if (mod.checklistPath && mod.reportPath) {
      addMenuItem(`
          <li>
            <a class="has-arrow" href="#">
              <div class="menu-icon"><i class="fa ${mod.icon}"></i></div>
              <span class="nav-text">${t(`menu.${mod.key}.title`)}</span>
            </a>
            <ul class="mm-collapse">
              <li><a href="${mod.checklistPath}">${t(`menu.${mod.key}.checklist`)}</a></li>
              <li><a href="${mod.reportPath}">${t(`menu.${mod.key}.report`)}</a></li>
            </ul>
          </li>
        `);
    } else if (mod.children) {
      // Filter children based on required rights (with support for alternative rights using OR logic)
      const filteredChildren = mod.children.filter(item => {
        if (item.isSubmenu) {
          return item.children.some(subItem => {
            if (subItem.requiredRight) {
              const hasMainRight = hasSpecificRight(user, subItem.requiredRight);
              const hasAltRight = subItem.alternativeRight ? hasSpecificRight(user, subItem.alternativeRight) : false;
              return hasMainRight || hasAltRight;
            }
            return true;
          });
        }
        if (item.requiredRight) {
          const hasMainRight = hasSpecificRight(user, item.requiredRight);
          const hasAltRight = item.alternativeRight ? hasSpecificRight(user, item.alternativeRight) : false;
          return hasMainRight || hasAltRight;
        }
        return true;
      });

      // Only show the menu if there are visible children
      if (filteredChildren.length > 0) {
        const menuItemId = mod.key === 'admin' ? 'admin-menu-item' : '';
        
        const renderMenuItem = (item) => {
          if (item.isSubmenu) {
            // Filter submenu children based on required rights (with support for alternative rights using OR logic)
            const filteredSubmenuChildren = item.children.filter(subItem => {
              if (subItem.requiredRight) {
                const hasMainRight = hasSpecificRight(user, subItem.requiredRight);
                const hasAltRight = subItem.alternativeRight ? hasSpecificRight(user, subItem.alternativeRight) : false;
                return hasMainRight || hasAltRight;
              }
              return true;
            });
            
            // Only render submenu if there are visible children
            if (filteredSubmenuChildren.length > 0) {
              return `
                <li>
                  <a class="has-arrow" href="#">
                    <span class="nav-text">${t(`menu.admin.${item.labelKey}`)}</span>
                  </a>
                  <ul class="mm-collapse">
                    ${filteredSubmenuChildren.map(subItem => `
                      <li><a href="${subItem.path}">${t(`menu.admin.${subItem.labelKey}`)}</a></li>
                    `).join('')}
                  </ul>
                </li>
              `;
            }
            return '';
          } else {
            // Use admin prefix for translation paths to maintain compatibility
            const translationKey = (mod.key === 'form' || mod.key === 'vocs' || mod.key === 'users') 
              ? `menu.admin.${mod.key}.${item.labelKey}` 
              : `menu.${mod.key}.${item.labelKey}`;
            return `<li><a href="${item.path}">${t(translationKey)}</a></li>`;
          }
        };
        
        // Use admin prefix for translation paths to maintain compatibility
        const titleTranslationKey = (mod.key === 'form' || mod.key === 'vocs' || mod.key === 'users') 
          ? `menu.admin.${mod.key}.title` 
          : `menu.${mod.key}.title`;
        
        addMenuItem(`
            <li ${menuItemId ? `id="${menuItemId}"` : ''}>
              <a class="has-arrow" href="#">
                <div class="menu-icon"><i class="fa ${mod.icon}"></i></div>
                <span class="nav-text">${t(titleTranslationKey)}</span>
              </a>
              <ul class="mm-collapse">
                ${filteredChildren.map(item => renderMenuItem(item)).join('')}
              </ul>
            </li>
          `);
      }
    } else if (mod.reportPath) {
      addMenuItem(`
          <li>
            <a href="${mod.reportPath}">
              <div class="menu-icon"><i class="fa ${mod.icon}"></i></div>
              <span class="nav-text">${t(`menu.${mod.key}.title`)}</span>
            </a>
          </li>
        `);
    }
  });

  // Initialize menu plugins
  menu.metisMenu("dispose");
  menu.metisMenu();
  
  // Add double-click functionality to Admin menu item
  // const adminMenuItem = document.getElementById('admin-menu-item');
  // if (adminMenuItem) {
  //   const adminLink = adminMenuItem.querySelector('a.has-arrow');
  //   if (adminLink) {
  //     adminLink.addEventListener('dblclick', function(e) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       // Navigate to admin dashboard
  //       window.location.href = '/admin';
  //     });
      
  //     // Add visual feedback on double-click capability
  //     adminLink.style.cursor = 'pointer';
  //     adminLink.title = t("doubleClickForDashboard", { ns: 'labels' }) || 'Doppio click per accedere alla dashboard amministrativa';
  //   }
  // }
  
  // Update language selector texts after menu initialization
  if (typeof window.updateLanguageSelectorTexts === 'function') {
    window.updateLanguageSelectorTexts();
  }
};

// we can import (t) to translate everywhere e i18n to change the language or add resources in runtime

// Make translation function available globally for language selector
window.getMenuTranslation = t;
window.getMenuI18n = () => i18n;

export {
  write,
  write_user,
  i18n,
  t
};